/**
 * 保留 object 中的部分内容
 * @param obj
 * @param keys
 */
export function pick(obj, keys) {
    var r = {};
    keys.forEach(function (key) {
        r[key] = obj[key];
    });
    return r;
}
//# sourceMappingURL=pick.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts-for-react/esm/helper/pick.js
// module id = 6749
// module chunks = 0